var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"switch-container"},[_c('v-switch',{attrs:{"label":_vm.isOn ? _vm.onText : _vm.offText,"color":"primary"},model:{value:(_vm.isOn),callback:function ($$v) {_vm.isOn=$$v},expression:"isOn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }